import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/Auth/Logout"

export class LogoutCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand();
        return new ApiGenericResponse(res);
    }
}

